import {BaseView} from '../core/view';
import constants from './constants';
import { ApiUtil } from '../utils/api-util';
import { LinkUtil } from '../utils/link';
import {JSErrorTracking} from '../utils/js-error-tracking';

export default BaseView.extend({

    el: '.js-categories-tab',
    urlParams: undefined,
    applyIsActive: false,
    categoriesData: [],
    initialActiveCategories: [],
    initialCategoryId: undefined,
    categoriesList: [],
    currentCategory: undefined,
    parentCategory: undefined,
    direction: undefined,
    firstLoad: true,
    
    templates: {
        LIST_CATEGORY_TEMPLATE: require("./templates/mobile-category-list-template.hbs"),
        LIST_CATEGORY_CONTENT_TEMPLATE:  require("./templates/mobile-category-content-template.hbs")
    },

    events: {
        'click .js-select-category' : 'onCategoryClick',
        'click .js-go-to-category' : 'onLastCategoryClick',
        'click .js-categories-back' : 'onBackClick',
        'click .js-categories-view-all' : 'onViewAllClick'
    },

    initialize: function() {
    	const self = this;
    	const dataElement = document.querySelector('#searchfeed');
    	this.urlParams = dataElement.getAttribute('data-active-categories');
    	this.initialCategoryId = dataElement.getAttribute('data-active-category');
        this.parseInitialActiveCategories();
        this.getCategoryData();
        
    },
    
    parseInitialActiveCategories: function() {
        var self = this;
        var initialActiveFiltersString = self.urlParams;
        if (initialActiveFiltersString!=""){
            initialActiveFiltersString=initialActiveFiltersString.split('&');
            _.each(initialActiveFiltersString,function(el){
                var itm = el.split('=');
                var value = (itm[0] == "tag" || itm[0] == "vertical") ? parseInt(itm[1]) : itm[1];
                self.initialActiveCategories.push({type: itm[0], value: value});
            });
        }
        
    },
    
    onViewAllClick: function(){
        LinkUtil.goToUrl(this.currentCategory.url);
    },
    
    onBackClick: function(){
        if (this.parentCategory!=undefined){
            this.currentCategory = this.parentCategory;
            this.direction = 'backward';
            this.fillList();
        }
    },
    
    onCategoryClick: function(e){
        e.preventDefault();
        var elem = this.$el.find(e.currentTarget);
        this.currentCategory = {
            id : elem.data('category-id'),
            name : elem.data('category-name'),
            url : elem.data('category-url')
        }
        this.direction = 'forward';
        this.fillList();
    },
    
    animateChange: function(){
        var self = this;
        var currentElem = self.$el.find('.js-category-current');
        var newElem = self.$el.find('.js-category-new');
        if (self.direction=='forward'){
            setTimeout(function(){
                currentElem.addClass('exit-left');
                newElem.addClass('tab-view__content-page--animate enter-left');
            }, 5);
            setTimeout(function(){
                newElem.removeClass('js-category-new').removeClass('tab-view__content-page--loaded tab-view__content-page--animate').removeClass('enter-left');
                currentElem.remove();
            }, 390);
        }else if (self.direction=='backward'){
            setTimeout(function(){
                currentElem.addClass('exit-right');
                newElem.addClass('tab-view__content-page--animate enter-right');
            }, 5);
            setTimeout(function(){
                newElem.removeClass('js-category-new').removeClass('tab-view__content-page--loaded tab-view__content-page--animate').removeClass('enter-right');
                currentElem.remove();
            }, 390);
        }
        
    },
    
    manageControlBar: function(){
        var self = this,
        buttonBack = this.$el.find('.js-categories-back'),
        buttonViewAll = this.$el.find('.js-categories-view-all'),
        buttonViewAllLabel = buttonViewAll.find('.js-all-products-string'),
        buttonViewAllCategoryLabel = buttonViewAll.find('.js-categories-current');
        
        if (self.parentCategory==undefined){
            buttonBack.addClass('button--inactive');
            buttonViewAllLabel.hide();
        }else{
            buttonBack.removeClass('button--inactive');
            buttonViewAllLabel.show();
        }
        buttonViewAllCategoryLabel.html(self.currentCategory.name);
        
    },
    
    recursiveFilter: function(current, depth, parent, activeCategoryId){
        var self = this;
        
        if ((depth==0)&&(current.id == activeCategoryId)){
            self.currentCategory = {
                            id: current.id,
                            name: current.name,
                            url: current.url
                        };
            self.parentCategory = undefined;
            self.categoriesList = current.children;
        }else{
            var currentChildren = _.find(current.children, { id : activeCategoryId});
            if (currentChildren!=undefined){
            	
            	if (currentChildren.children.length>0){
                    self.parentCategory = {
                        id: current.id,
                        name: current.name,
                        url: current.url
                    }
                    self.currentCategory = {
                        id: currentChildren.id,
                        name: currentChildren.name,
                        url: currentChildren.url
                    }
                    self.categoriesList = currentChildren.children;
                }else{
                    self.parentCategory = {
                        id: parent.id,
                        name: parent.name,
                        url: parent.url
                    }
                    self.currentCategory = {
                        id: current.id,
                        name: current.name,
                        url: current.url
                    }
                    self.categoriesList = current.children;
                }
                
            }

            var children = current.children;
            for (var i = 0, len = children.length; i < len; i++) {
                self.recursiveFilter(children[i], depth + 1, current, activeCategoryId);
            }
        }
    },
    
    fillList: function(){
        var self = this,
        activeCategoryId,
        code = "",
        categoriesContainer = self.$el.find(".js-categories-container");
        
        if(self.currentCategory == undefined) {
        	activeCategoryId = parseInt(self.initialCategoryId);
        } else {
        	activeCategoryId = parseInt(self.currentCategory.id);
        }
        
        self.recursiveFilter(self.categoriesData, 0, undefined, activeCategoryId);
        self.manageControlBar();
        
        
        var data = {
            name: (self.currentCategory.id != 0 ? getI18N(jlocale.viewall) : "") + " " + self.currentCategory.name,
            id: self.currentCategory.id,
            url: self.currentCategory.url,
            active: false,
            hasChildren: false,
        }
        
        code += self.templates.LIST_CATEGORY_TEMPLATE(data);
        
        
        $.each(self.categoriesList, function(i, val) {
            
            var data = {
                name: val.name,
                id: val.id,
                url: val.url,
                active: val.id == self.initialCategoryId,
                hasChildren: val.children.length > 0,
            }
            
            code += self.templates.LIST_CATEGORY_TEMPLATE(data);

        });
        if (self.firstLoad){
            code = self.templates.LIST_CATEGORY_CONTENT_TEMPLATE({list : code});
            categoriesContainer.html(code);
            self.firstLoad = false;
        }else{
            self.$el.find('.js-category-page').addClass('js-category-current');
            code = self.templates.LIST_CATEGORY_CONTENT_TEMPLATE({list : code, customClass : "js-category-new tab-view__content-page--loaded"});
            categoriesContainer.append(code);
            self.animateChange();
        }

        
    },
    
    getCategoryData: _.once(function() {
        var self = this;
        var activeGender = _.find(self.initialActiveCategories,{type:"gender"});
        var requestAdditionalString = "";
        if (activeGender!=undefined){
            requestAdditionalString="?gender="+activeGender.value;
        }
        
        ApiUtil.request({
            path: constants.CATEGORIES_REQUEST_DATA_URL + requestAdditionalString,
            success: function(data) {
                if (data.length>0){
                    JSErrorTracking.sendCustomError("Sort API Error - Data is empty");
                }
                self.categoriesData = data.categoryTree;
                
                self.fillList();
                self.$el.addClass('tab-view__content--loaded');
            },
            error: function(xhr, error){
                JSErrorTracking.sendCustomError("Filter API Error - URL not found - status:"+xhr.status);
            }
        });
        

    })
    

    
});
